import React, {useState, useEffect} from "react";
import "./ProgressBox.css";
import styled, {css} from "styled-components";
import {useSelector} from "react-redux";
import loadingBoxImage from "images/common/loading-box.png";
import loadingScreenVideo from "videos/common/loading-screen-video.mp4";
import {getWorld} from "api-v3";

const DarkBackground = styled.div`
  display: none;
  position: fixed;
  z-index: 30;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);

  ${props =>
    props.disappear &&
    css`
      display: block;
    `}
`;

function ProgressBox({percentage, loaded, processName}) {
  const isPlayMode =
    useSelector(state => {
      return state.mode.studioMode;
    }) === "play";
  const progress = document.querySelector(".progress-bar");
  if (progress) {
    progress.style.width = percentage + "%";
  }
  const [imageUrl, setImageUrl] = useState(null);
  const [text, setText] = useState("");

  useEffect(() => {
    async function getWorldData() {
      if (imageUrl && text) return;
      if (processName === "SCENE_FETCH" || processName === "SERVER_SCENE_FETCH" || processName === "UNITY_FETCH") {
        const queryParams = new URLSearchParams(window.location.search);
        const pid = queryParams.get("pid");
        const gameData = await getWorld({id: pid});
        setImageUrl(gameData?.data?.icon);
        setText(gameData?.data?.name);
      }
    }
    getWorldData();
  }, [processName, imageUrl, text]);

  if (loaded) {
    if (processName === "UNITY_FETCH") {
      setTimeout(() => {
        return <></>;
      }, 2000);
    } else return <></>;
  }
  if (processName === "SCENE_FETCH" || processName === "UNITY_FETCH") {
    return (
      <div className="playmode_background">
        <video className="loading_screen_video" autoPlay loop muted>
          <source src={loadingScreenVideo} type="video/mp4" />
        </video>
        <div className="thumbnail_container">
          <div className="thumbnail_wrapper">
            <img className="thumbnail_image" src={imageUrl} alt={""} loading="lazy" />
          </div>
          <div className="thumbnail_text">{text}</div>
        </div>
        <div className="loading_bar_background">
          <p className={`progress_bar_text${isPlayMode ? " play_mode" : ""}`}>
            {percentage !== undefined ? parseInt(percentage) + "%" : ""}
          </p>
          <div className="progress-bar-container">
            <div className="progress-bar"></div>
          </div>
          <p className="powered-by-redbrick">Powered by Redbrick Engine</p>
        </div>
      </div>
    );
  } else if (processName === "SERVER_SCENE_FETCH") {
    return (
      <div className="playmode_background">
        <video className="loading_screen_video" autoPlay loop muted>
          <source src={loadingScreenVideo} type="video/mp4" />
        </video>
        <div className="thumbnail_container">
          <div className="thumbnail_wrapper">
            <img className="thumbnail_image" src={imageUrl} alt={""} loading="lazy" />
          </div>
          <div className="thumbnail_text">{text}</div>
        </div>
        <div className="loading_bar_background">
          <p className={`progress_bar_text${isPlayMode ? " play_mode" : ""}`}>
            Connecting to server ... {percentage !== undefined ? parseInt(percentage) + "%" : ""}
          </p>
          <div className="progress-bar-container">
            <div className="progress-bar"></div>
          </div>
          <p className="powered-by-redbrick">Powered by Redbrick Engine</p>
        </div>
      </div>
    );
  } else {
    return (
      <DarkBackground disappear={!loaded}>
        <div className="progress_box_background">
          <img src={loadingBoxImage} className={`progress_box_img${isPlayMode ? " play_mode" : ""}`} alt="loading"></img>
          <p className={`progress_box_text${isPlayMode ? " play_mode" : ""}`}>
            {percentage !== undefined ? parseInt(percentage) + "%" : ""}
          </p>
        </div>
      </DarkBackground>
    );
  }
}

export default ProgressBox;
